<template>
    <!-- Filters -->
    <div>
      <preloading-analytic-kpis v-if="loading"/>
      <div v-else class="w-100 h-screen bg-white">
        <iframe
          title="QuickSight Dashboard"
          :src="dashboardUrl"
          frameborder="0"
          allowfullscreen
          class="w-100 h-full"
          style="min-height: 800px;">
        </iframe>
      </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import preloadingAnalyticKpis from '../../../components/loadings/placeholderAnalyticKpis.vue';
export default {
  name: "dashboard-kpis",
  components: {
    preloadingAnalyticKpis
  },
  data() {
    return {
      loading: true,
      dashboardUrl: ''
    };
  },
  computed: {
    ...mapGetters(["authentication_user"]),
  },
  watch: {
      'authentication_user.client_business_select'(newVal, oldVal) {
          if (newVal !== oldVal) {
              this.getFilter();
          }
      }
  },
  created(){
    this.getFilter()
  },
  methods: {
    ...mapActions([
        'get'
    ]),
    getFilter(){
      this.loading = true;
      let client_name = `c-${this.authentication_user.client_name.toLowerCase().replace(/\s+/g, '')}`;
      let business = this.authentication_user.client_business_select ? this.authentication_user.client_business_select : null;
      let url = `https://u6r680bho3.execute-api.us-east-1.amazonaws.com/prod/dashboard-url/?client_name=${client_name}&client_product=kpis`
      if (business){
        url = `https://u6r680bho3.execute-api.us-east-1.amazonaws.com/prod/dashboard-url/?client_name=${client_name}&client_product=kpis&client_business=${business}`
      }
      this.get({
        url: url
      }).then((response) => {
        this.dashboardUrl = response.url;
        this.loading = false
      })
    }
  }
};
</script>